import { Colors } from '@zapier/design-system';
import { COLOR_KEYS } from '../../../constants';
import { SplitColorAccordionSectionProps } from './SplitColorAccordionSection';

export const DEFAULT_VALUES: SplitColorAccordionSectionProps = {
  accordionItems: [
    {
      heading: 'Multi-step workflows',
      body: '<p>Create automated workflows that do more than just one thing—up to 100 steps, to be specific!</p>',
      animationDataUrl:
        'https://assets9.lottiefiles.com/packages/lf20_bigdx6cj.json',
      mediaAltText: 'Animation of shapes moving',
    },
    {
      heading: 'Conditional logic',
      body: '<p>Add customized if/then logic to your workflows so they work exactly how you would—but automatically.</p>',
      animationDataUrl:
        'https://assets4.lottiefiles.com/packages/lf20_8ttxp7rk.json',
      mediaAltText: 'Animation of shapes moving',
    },
    {
      heading: 'Data formatting',
      body: '<p>Transform data from one app into the right format before passing it on to another app. No data science degree required!</p>',
      animationDataUrl:
        'https://assets2.lottiefiles.com/packages/lf20_gjgicmzg.json',
      mediaAltText: 'Animation of shapes moving',
    },
  ],
  backgroundColor: COLOR_KEYS.moss,
  ctaText: 'Discover more features',
  ctaUrl: '#',
  heading: `Start simple, <span style="color: ${Colors.zapier}">scale to sophistication</span>`,
};
